import {
    CanvasCategoryKey,
    GeneralCategoryKey,
    LinkCategoryKey,
    MessagesAndEventsCategoryKey,
    SearchResultsCategoryKey,
    TaskCategoryKey,
} from './getTimeStreamHotkeyCategories';
import type { HotkeyCommand, Hotkeys } from 'owa-hotkeys';
import loc from 'owa-localize';
import {
    saveChangesCommandDescription,
    revertChangesCommandDescription,
    searchItemCommandDescription,
    zoomInCommandDescription,
    zoomOutCommandDescription,
    panLeftRightCommandDescription,
    panUpDownCommandDescription,
    resetPanAndZoomCommandDescription,
    moveItemLeftRightCommandDescription,
    moveItemUpDownCommandDescription,
    deleteSelectedItemsCommandDescription,
    deselectItemsCommandDescription,
    openLinkCommandDescription,
    resolveLinkCommandDescription,
    editTitleCommandDescription,
    shiftTaskUpDownCommandDescription,
    deleteSubtaskCommandDescription,
    openItemInNewWindowCommandDescription,
    addItemToCanvasCommandDescription,
    lockBoardCommandDescription,
    lockAssetsCommandDescription,
} from './TimeStreamHotkeys.locstring.json';

export default function getTimeStreamHotkeyCommands(): Required<HotkeyCommand>[] {
    return [
        generalHotkey(saveChangesCommandDescription, 'enter'),
        generalHotkey(revertChangesCommandDescription, 'esc'),
        canvasHotkey(searchItemCommandDescription, 'ctrl+shift+k'),
        canvasHotkey(zoomInCommandDescription, 'ctrl+]' /* 'shift++', 'shift+='*/),
        canvasHotkey(zoomOutCommandDescription, 'ctrl+[' /*, 'shift+-' */),
        canvasHotkey(panLeftRightCommandDescription, ['ctrl+left', 'ctrl+right']),
        canvasHotkey(panUpDownCommandDescription, ['ctrl+up', 'ctrl+down']),
        canvasHotkey(resetPanAndZoomCommandDescription, 'ctrl+0'),
        canvasHotkey(moveItemLeftRightCommandDescription, ['ctrl+shift+left', 'ctrl+shift+right']),
        canvasHotkey(moveItemUpDownCommandDescription, ['ctrl+shift+up', 'ctrl+shift+down']),
        canvasHotkey(deleteSelectedItemsCommandDescription, 'del'),
        canvasHotkey(deselectItemsCommandDescription, 'esc'),
        canvasHotkey(lockBoardCommandDescription, 'shift+l+c'),
        canvasHotkey(lockAssetsCommandDescription, 'shift+l+i'),
        linkHotkey(openLinkCommandDescription, 'ctrl+click'),
        linkHotkey(resolveLinkCommandDescription, 'ctrl+enter'),
        linkHotkey(editTitleCommandDescription, 'f2'),
        taskHotkey(shiftTaskUpDownCommandDescription, ['alt+shift+up', 'alt+shift+down']),
        taskHotkey(deleteSubtaskCommandDescription, 'del'),
        messagesAndEventsHotkey(openItemInNewWindowCommandDescription, 'enter' /*'space'*/),
        searchResultsHotkey(addItemToCanvasCommandDescription, 'enter' /*'space'*/),
    ];
}

function hotkey(
    category: string,
    descriptionResourceId: string,
    hotkey: Hotkeys
): Required<HotkeyCommand> {
    return {
        category,
        description: loc(descriptionResourceId),
        isDisabled: false,
        hotmail: hotkey,
        yahoo: hotkey,
        gmail: hotkey,
        owa: hotkey,
        outlook: hotkey,
    };
}

const generalHotkey = hotkey.bind(null, GeneralCategoryKey);
const canvasHotkey = hotkey.bind(null, CanvasCategoryKey);
const linkHotkey = hotkey.bind(null, LinkCategoryKey);
const taskHotkey = hotkey.bind(null, TaskCategoryKey);
const messagesAndEventsHotkey = hotkey.bind(null, MessagesAndEventsCategoryKey);
const searchResultsHotkey = hotkey.bind(null, SearchResultsCategoryKey);
